import React, { useContext, useState } from 'react';
import { Container, Nav, Navbar, NavDropdown, Offcanvas } from 'react-bootstrap';
import { useLocation, Link } from "react-router-dom";
import { RiLogoutBoxRLine, RiMenu3Line, RiCloseLine } from "react-icons/ri";
import { AuthContext } from '../../context/authContext';
import logo from '../Photos/logo.svg';
import '../css/handf/Navigationbar.css';

const Navigationbar = () => {
  const location = useLocation();
  const { logout, user } = useContext(AuthContext);

  // Offcanvas (Sidebar) state
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    // Close all dropdowns when sidebar closes
    setShowDoc(false); setShowad(false); setShowpros(false);
    setShowNagal(false); setShowEC(false);
  };
  const handleShow = () => setShow(true);

  // Independent states for Dropdowns
  const [showDoc, setShowDoc] = useState(false);
  const [showad, setShowad] = useState(false);
  const [showpros, setShowpros] = useState(false);
  const [showNagal, setShowNagal] = useState(false);
  const [showEC, setShowEC] = useState(false);
  const [showCl, setShowCl] = useState(false);


  // Logic: Only allow hover on screens larger than 992px
  const isDesktop = () => window.innerWidth > 992;

  const handleMouseEnter = (setter) => isDesktop() && setter(true);
  const handleMouseLeave = (setter) => isDesktop() && setter(false);
  
  // Logic: Toggle click only on Mobile
  const handleToggleClick = (setter, currentVal) => {
    if (!isDesktop()) setter(!currentVal);
  };

  const TitleCase = (str) => {
    return str ? str.toLowerCase().trim().split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ') : "User";
  };

  const isActive = (paths) => paths.includes(location.pathname) ? 'active' : '';

  return (
    <div className='modern-navbar'>
      <Navbar expand="lg" className="container-xxl py-2 shadow-sm">
        <Container fluid className="px-lg-5">
          
          {/* MOBILE LOGO */}
          <Navbar.Brand as={Link} to="/home" className="d-md-none nav-brand-anim" onClick={handleClose}>
            <img src={logo} alt="logo" style={{ height: "45px" }} />
          </Navbar.Brand>

          {/* TOGGLE BUTTON */}
          <Navbar.Toggle aria-controls="navbar-offcanvas" onClick={handleShow} className="border-0 p-0 shadow-none ms-auto">
            <RiMenu3Line size={28} color="#dbe72d" />
          </Navbar.Toggle>

          {/* OFFCANVAS */}
          <Navbar.Offcanvas id="navbar-offcanvas" placement="end" show={show} onHide={handleClose} className="modern-offcanvas">
            <Offcanvas.Header className="px-4 pt-4 justify-content-between">
              <Offcanvas.Title className="text-white fw-bold">MENU</Offcanvas.Title>
              <button className="btn-close-custom" onClick={handleClose}>
                <RiCloseLine size={30} color="white" />
              </button>
            </Offcanvas.Header>

            <Offcanvas.Body className="px-4">
              <Nav className="w-100 align-items-lg-center">
                
                <Nav.Link as={Link} to="/dashboard" onClick={handleClose} className={`modern-link nav-anim-1 ${location.pathname === '/dashboard' ? 'active' : ''}`}>
                  Dashboard
                </Nav.Link>

                {/* PROCESSING DROPDOWN */}
                <NavDropdown
                  title={<span className="modern-link">Processing</span>}
                  className={`modern-dropdown nav-anim-2 s ${location.pathname === '/home' ? 'active' : ''}`}
                  show={showpros}
                  onMouseEnter={() => handleMouseEnter(setShowpros)}
                  onMouseLeave={() => handleMouseLeave(setShowpros)}
                  onClick={() => handleToggleClick(setShowpros, showpros)}
                >
                  <NavDropdown.Item as={Link} to="/home" state={{ mountSection: 'doc' }} onClick={handleClose}>Document</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/home" state={{ mountSection: 'nl' }} onClick={handleClose}>Nagal</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/home" state={{ mountSection: 'ec' }} onClick={handleClose}>Encumbrance Certificate(EC)</NavDropdown.Item>
                </NavDropdown>

                {/* DOCUMENT DROPDOWN */}
                <NavDropdown
                  title={<span className="modern-link">Document</span>}
                  className={`modern-dropdown nav-anim-3 s ${isActive(['/register', '/mydoc'])}`}
                  show={showDoc}
                  onMouseEnter={() => handleMouseEnter(setShowDoc)}
                  onMouseLeave={() => handleMouseLeave(setShowDoc)}
                  onClick={() => handleToggleClick(setShowDoc, showDoc)}
                >
                  <NavDropdown.Item as={Link} to="/register" onClick={handleClose}>Create Document</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/mydoc" onClick={handleClose}>My Document</NavDropdown.Item>
                </NavDropdown>

                {/* NAGAL DROPDOWN */}
                <NavDropdown
                  title={<span className="modern-link">Nagal</span>}
                  className={`modern-dropdown nav-anim-4 s ${isActive(['/nl_register', '/mynl'])}`}
                  show={showNagal}
                  onMouseEnter={() => handleMouseEnter(setShowNagal)}
                  onMouseLeave={() => handleMouseLeave(setShowNagal)}
                  onClick={() => handleToggleClick(setShowNagal, showNagal)}
                >
                  <NavDropdown.Item as={Link} to="/nl_register" onClick={handleClose}>Create Nagal</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/mynl" onClick={handleClose}>My Nagal</NavDropdown.Item>
                </NavDropdown>

                {/* EC DROPDOWN */}
                <NavDropdown
                  title={<span className="modern-link">Encumbrance Certificate(EC)</span>}
                  className={`modern-dropdown nav-anim-5 s ${isActive(['/ec_register', '/myec'])}`}
                  show={showEC}
                  onMouseEnter={() => handleMouseEnter(setShowEC)}
                  onMouseLeave={() => handleMouseLeave(setShowEC)}
                  onClick={() => handleToggleClick(setShowEC, showEC)}
                >
                  <NavDropdown.Item as={Link} to="/ec_register" onClick={handleClose}>Create Encumbrance Certificate(EC)</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/myec" onClick={handleClose}>My Encumbrance Certificate(EC)</NavDropdown.Item>
                </NavDropdown>

                <Nav.Link as={Link} to="/print-label" onClick={handleClose} className={`modern-link nav-anim-6 ${location.pathname === '/print-label' ? 'active' : ''}`}>
                  Print Label
                </Nav.Link>

                <NavDropdown
                    title={<span className="modern-link">Clients</span>}
                    className={`modern-dropdown nav-anim-8 s ${location.pathname === '/client' ? 'active' : ''}`}
                    show={showCl}
                    onMouseEnter={() => handleMouseEnter(setShowCl)}
                    onMouseLeave={() => handleMouseLeave(setShowCl)}
                    onClick={() => handleToggleClick(setShowCl, showCl)}
                  >
                    <NavDropdown.Item as={Link} to="/client" state={{ mountSection: 'regular' }} onClick={handleClose}>Existing</NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/client" state={{ mountSection: 'app' }} onClick={handleClose}>App</NavDropdown.Item>
                  </NavDropdown>

                {/* ADMIN DROPDOWN */}
                {user?.role === 'admin' && (
                  <NavDropdown
                    title={<span className="modern-link">Admin</span>}
                    className={`modern-dropdown nav-anim-8 s ${location.pathname === '/admin' ? 'active' : ''}`}
                    show={showad}
                    onMouseEnter={() => handleMouseEnter(setShowad)}
                    onMouseLeave={() => handleMouseLeave(setShowad)}
                    onClick={() => handleToggleClick(setShowad, showad)}
                  >
                    <NavDropdown.Item as={Link} to="/admin" state={{ mountSection: 'dash' }} onClick={handleClose}>Dashboard</NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/admin" state={{ mountSection: 'office' }} onClick={handleClose}>Office</NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/admin" state={{ mountSection: 'resource' }} onClick={handleClose}>Resource</NavDropdown.Item>
                  </NavDropdown>
                )}

                {/* PROFILE SECTION */}
                <div className="ms-lg-auto d-flex flex-column flex-md-row align-items-start align-items-md-center gap-3 mt-4 mt-md-0 nav-anim-9">
                  <div className="user-profile-pill">
                    <div className='d-flex align-items-center'>
                      <div className="user-avatar-circle" style={{ width: '40px', height: '40px', border: '1px solid yellow', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                        {user?.profileImage ? (
                          <img src={user.profileImage} alt={user.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        ) : (
                          <span style={{ color: 'yellow', fontWeight: 'bold' }}>{user?.name?.charAt(0).toUpperCase()}</span>
                        )}
                      </div>
                      <div className="ms-2">
                        <span className="user-name d-block">{TitleCase(user?.name)}</span>
                        <span className="user-role d-block" style={{ fontSize: '11px', color: 'orange' }}>{TitleCase(user?.role)}</span>
                      </div>
                    </div>
                  </div>
                  <button className="logout-icon-btn" onClick={() => { handleClose(); logout(); }}>
                    <RiLogoutBoxRLine size={24} color="white" />
                  </button>
                </div>

              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>
    </div>
  );
};

export default Navigationbar;